import axios from 'axios';
import React, { useContext, useEffect, useState } from 'react'
import { ProductContext } from '../../App';

function EditAccount(props) {

    const product_context = useContext(ProductContext);
    const { setIsLoading, alert, setAlert } = product_context;

    const { editAccount, setEditAccount, reload } = props;

    const [editAccountInputs, setEditAccountInputs] = useState('');

    const { isOpen, account, toEdit } = editAccount;

    useEffect(() => {
        if (toEdit === 'total_invested' || toEdit === 'zishan' || toEdit === 'shadab') {
            setEditAccountInputs(account[toEdit]?.amount || '');
        }
        else {
            setEditAccountInputs(account[toEdit] || '');
        }
        // eslint-disable-next-line
    }, [isOpen])

    const handleEditSubmit = (e) => {
        e.preventDefault();
        setIsLoading(true);

        let data = {}
        if (toEdit === 'total_invested' || toEdit === 'zishan' || toEdit === 'shadab') {
            let dates = [...account[toEdit]?.updated_date];
            dates.push({
                date: new Date(),
                amount: account[toEdit]?.amount || 0,
            });
            data[toEdit] = {
                amount: editAccountInputs,
                updated_date: dates,
            }
        }
        else {
            data[toEdit] = editAccountInputs;
        }

        axios.put(`${process.env.REACT_APP_SERVER_DOMAIN}/account/${account._id}`, data)
            .then(res => {
                setAlert({
                    isOpen: true,
                    message: "Acount Updated",
                    type: 'success'
                });
                reload();
            })
            .catch(err => {
                setAlert({
                    isOpen: true,
                    message: "Something went wrong",
                    type: 'danger'
                });
            })
        setTimeout(() => {
            setAlert({ ...alert, isOpen: false })
        }, 5000);
        setIsLoading(false);
        setEditAccount({ ...editAccount, isOpen: false });
    }


    return (
        <>
            {isOpen ? <div className='back'>
                <div className="edit-container flex-column">
                    <h2>Edit</h2>
                    <div className="edit-form">
                        <form onSubmit={handleEditSubmit}>
                            <div className="inputs">
                                <label htmlFor="amount">Amount</label>
                                <input type="number"
                                    value={editAccountInputs}
                                    onChange={(e) => {
                                        setEditAccountInputs(e.target.value);
                                    }}
                                    required
                                    placeholder='Enter Amount' name='amount'
                                />
                            </div>
                            <div>
                                <button type='submit' className='btn btn-success mx-2'>Submit</button>
                                <button onClick={() => {
                                    setEditAccount({ ...editAccount, isOpen: false });
                                }} className='btn btn-danger'>Cancel</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div> : null}
        </>
    )
}

export default EditAccount
